import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, TableCell, Typography } from "@mui/material";
import React from "react";

import EquipmentAPI from "../api/Equipment.api";
import BasicCreateModal from "../components/BasicCreateModal";
import Layout from "../components/Layout";
import ListModel from "../components/ListModel";
import { Equipment, TableColumn } from "../types";
import { extractDate } from "../utils";

const columns: TableColumn<Equipment>[] = [
  { field: "name", label: "Name" },
  { field: "createdAt", label: "Created At Date" },
];

function buildTableRow(equipment: Equipment): JSX.Element[] {
  return [
    <TableCell key={"name"}>{equipment.name}</TableCell>,
    <TableCell key={"createdAt"}>{extractDate(equipment.createdAt)}</TableCell>,
  ];
}

export default function EquipmentList() {
  const [openModel, setOpenModal] = React.useState<boolean>(false);
  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Equipments</Typography>
          <Button onClick={() => setOpenModal(true)}>
            <AddCircleIcon />
          </Button>
        </Box>

        <ListModel
          defaultOrderBy={"name"}
          modelApiUseList={EquipmentAPI.useList}
          modelBaseUrl={"equipments"}
          columns={columns}
          buildTableRow={buildTableRow}
        />

        <BasicCreateModal
          open={openModel}
          onClose={() => setOpenModal(false)}
          modelApiUseSave={EquipmentAPI.useSave}
          navigateUrl="/equipments"
        />
      </Box>
    </Layout>
  );
}
